export default "__VITE_ASSET__282e4ba5__"